import {
  vuexfireMutations,
  // firestoreAction,
} from 'vuexfire';
import Vue from 'vue';
import Vuex from 'vuex';

import axios from 'axios';
// import createPersistedState from 'vuex-persistedstate';

import { db } from '@/db';
import { cloudFunctions } from '../config';

Vue.use(Vuex);

export default new Vuex.Store({
  // plugins: [createPersistedState()],

  state: {
    blueRingShowed: false,
    logout_dialog: false,
    buy_swipes_dialog: false,
    contentKey: 0,
    email: '',
    user_id: '',
    userType: '',
    user_data: {},
    bindedUserData: {},
    bindUserUnsubscribe: undefined,
    watchUserDataActive: true,
    oldMatches: 0,
    applications: [],
    visibleCards: [],
    loading: false,
    snackbar: false,
    snackText: '',
    currentChat_id: '',
    playersConnected: [],
    trainersConnected: [],
    aff: '',
    userMatches: null,
    newMatch: false,
    newMessagesCount: 0,
    chatImageToSave: null,
    onlineChatUsers: [],
    subscriptionData: undefined,
    payments: [],
    onlineUsersForFilters: [],
    badgeApiPresent: false,
    pushNotificationsAllowedInBrowser: true,
    askForPushPermition: false,
    accountDeleted: false,
    showPaymentsBlock: false,
    trainer_types: [
      'Cheftrainer/in',
      'Co-Trainer/in',
      'Nachwuchstrainer/in',
      'Torwarttrainer/in',
      'Fitnesstrainer/in',
      'Athletiktrainer/in',
      'Mentaltrainer/in',
    ],
    bundesland: [
      'Baden-Württemberg',
      'Bayern',
      'Berlin',
      'Brandenburg',
      'Bremen',
      'Hamburg',
      'Hessen',
      'Mecklenburg-Vorpommern',
      'Niedersachsen',
      'Nordrhein-Westfalen',
      'Rheinland-Pfalz',
      'Saarland',
      'Sachsen-Anhalt',
      'Sachsen',
      'Schleswig-Holstein',
      'Thüringen',
    ],
    search_states: [
      'Bundesweit',
      'Baden-Württemberg',
      'Bayern',
      'Berlin',
      'Brandenburg',
      'Bremen',
      'Hamburg',
      'Hessen',
      'Mecklenburg-Vorpommern',
      'Niedersachsen',
      'Nordrhein-Westfalen',
      'Rheinland-Pfalz',
      'Saarland',
      'Sachsen-Anhalt',
      'Sachsen',
      'Schleswig-Holstein',
      'Thüringen',
    ],
    scoutarea: [
      'Bundesweit',
      'Baden-Württemberg',
      'Bayern',
      'Berlin',
      'Brandenburg',
      'Bremen',
      'Hamburg',
      'Hessen',
      'Mecklenburg-Vorpommern',
      'Niedersachsen',
      'Nordrhein-Westfalen',
      'Rheinland-Pfalz',
      'Saarland',
      'Sachsen-Anhalt',
      'Sachsen',
      'Schleswig-Holstein',
      'Thüringen',
    ],
    trainer_license: [
      'Keine Lizenz',
      'Jugend-Elite-Lizenz',
      'C-Lizenz',
      'B-Lizenz',
      'A-Lizenz',
      'Fußballlehrer',
      'Eigene Angabe',
    ],
    scout_priority: ['Trainer', 'Spieler', 'Trainer & Spieler'],
    scout_segment: ['Profifußball', 'Amateurfußball'],
    seasons: ['2021/2022', '2020/2021', '2019/2020', '2018/2019', '2017/2018', '2016/2017',
      '2015/2016', '2014/2015', '2013/2014', '2012/2013', '2011/2012', '2010/2011',
      '2009/2010', '2008/2009', '2007/2008', '2006/2007', '2005/2006', '2004/2005',
      '2003/2004', '2002/2003', '2001/2002', '200/2001', '1999/2000', '1998/1999',
      '1997/1998', '1996/1997',
    ],
    leagues: [
      'Kreisklasse',
      'Kreisliga',
      'Kreisoberliga',
      'Landesklasse',
      'Landesliga',
      'Verbandsliga',
      'Oberliga',
      'Regionalliga',
      '3. Bundesliga',
      '2. Bundesliga',
      '1. Bundesliga',
    ],
    verband: ['Baden', 'Baden', 'Bayern', 'Berlin', 'Brandenburg', 'Bremen', 'Hamburg',
      'Hessen', 'Mecklenburg-Vorpommern', 'Mittelrhein', 'Niederrhein', 'Niedersachsen',
      'Rheinland', 'Saarland', 'Sachsen', 'Sachsen', 'Sachsen-Anhalt', 'Schleswig-Holstein',
      'Südbaden', 'Südwest', 'Thüringen', 'Westfalen', 'Württemberg',
    ],
    playerFoot: ['Rechts', 'Links', 'Beide'],
    filter_leagues: {
      Baden: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Verbandsliga',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      Bremen: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Bremenliga',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Bezirksliga',
        category: '8',
      },
      {
        league: 'Kreisliga/Stadtliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      Mittelrhein: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Mittelrheinliga',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Bezirksliga',
        category: '8',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      ],
      Saarland: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Saarlandliga',
        category: '6',
      },
      {
        league: 'Verbandsliga',
        category: '61',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Bezirksliga',
        category: '8',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      Südbaden: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Verbandsliga',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Bezirksliga',
        category: '8',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      ],
      Württemberg: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Verbandsliga',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Bezirksliga',
        category: '8',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      ],
      Bayern: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Bayernliga',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Bezirksliga',
        category: '8',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      Hamburg: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Oberliga Hamburg',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Bezirksliga',
        category: '8',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      Niederrhein: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Oberliga Niederrhein',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Bezirksliga',
        category: '8',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      ],
      Sachsen: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Landesklasse',
        category: '8',
      },
      {
        league: 'Kreisoberliga',
        category: '81',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      'Schleswig-Holstein': [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'OberligaSchleswig-Holstein',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '61',
      },
      {
        league: 'Verbandsliga',
        category: '7',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      Südwest: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Verbandsliga',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Bezirksliga',
        category: '8',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      ],
      Berlin: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Berlinliga',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Bezirksliga',
        category: '8',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      Hessen: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Hessenliga',
        category: '6',
      },
      {
        league: 'Verbandsliga',
        category: '61',
      },
      {
        league: 'Gruppenliga',
        category: '7',
      },
      {
        league: 'Kreisoberliga',
        category: '8',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      Niedersachsen: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Oberliga Niedersachsen',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Bezirksliga',
        category: '8',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      'Sachsen-Anhalt': [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Verbandsliga',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Landesklasse',
        category: '8',
      },
      {
        league: 'Kreisoberliga',
        category: '81',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      Thüringen: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Thüringenliga',
        category: '6',
      },
      {
        league: 'Landesklasse',
        category: '8',
      },
      {
        league: 'Kreisoberliga',
        category: '81',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      Brandenburg: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Brandenburgliga',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Landesklasse',
        category: '8',
      },
      {
        league: 'Kreisoberliga',
        category: '81',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      'Mecklenburg-Vorpommern': [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Verbandsliga',
        category: '6',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Landesklasse',
        category: '8',
      },
      {
        league: 'Kreisoberliga',
        category: '81',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      Rheinland: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Rheinlandliga',
        category: '6',
      },
      {
        league: 'Verbandsliga',
        category: '61',
      },
      {
        league: 'Bezirksliga',
        category: '7',
      },
      {
        league: 'Landesliga',
        category: '71',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      {
        league: 'Kreisklasse',
        category: '10',
      },
      ],
      Westfalen: [{
        league: '1. Bundesliga',
        category: '1',
      },
      {
        league: '2. Bundesliga',
        category: '2',
      },
      {
        league: '3. Bundesliga',
        category: '3',
      },
      {
        league: 'Regionalliga',
        category: '4',
      },
      {
        league: 'Oberliga',
        category: '5',
      },
      {
        league: 'Oberliga Westfalen',
        category: '6',
      },
      {
        league: 'Westfalenliga',
        category: '61',
      },
      {
        league: 'Landesliga',
        category: '7',
      },
      {
        league: 'Bezirksliga',
        category: '8',
      },
      {
        league: 'Kreisliga',
        category: '9',
      },
      ],
    },
    positions: ['Torhüter', 'Verteidiger', 'Mittelfeld', 'Angriff'],
    secondPositions: ['Keine', 'Torhüter', 'Verteidiger', 'Mittelfeld', 'Angriff'],
    positions_extended: ['Torhüter', 'Libero', 'Innenverteidiger', 'Linker Verteidiger',
      'Rechter Verteidiger', 'Linker Offensivverteidiger', 'Rechter Offensivverteidiger',
      'Defensives Mittelfeld', 'Zentrales Mittelfeld', 'Offensives Mittelfeld',
      'Linkes Mittelfeld', 'Rechtes Mittelfeld', 'Mittelstürmer', 'Linksaußen',
      'Rechtsaußen',
      'Falsche 9', 'Hängende Spitze',
    ],
    positionsWithoutSpecific: ['Keine', 'Torhüter'],
    strikerTypes: [
      'Mittelstürmer',
      'Linksaußen',
      'Rechtsaußen',
      'Falsche 9',
      'Hängende Spitze',
    ],
    perspective: ['Aufstieg', 'Etablierung', 'Klassenerhalt', 'Keine Angabe'],
    guardTypes: [
      'Libero',
      'Innenverteidiger',
      'Linker Verteidiger',
      'Rechter Verteidiger',
      'Linker Offensivverteidiger',
      'Rechter Offensivverteidiger',
    ],
    midfieldType: [
      'Defensives Mittelfeld',
      'Zentrales Mittelfeld',
      'Offensives Mittelfeld',
      'Linkes Mittelfeld',
      'Rechtes Mittelfeld',
    ],
    age_classes: ['Herren', 'Frauen', 'U19', 'U18', 'U17',
      'U16', 'U15', 'U14',
    ],
    languages: [
      'Deutsch',
      'Arabisch',
      'Bengalisch',
      'Chinesisch',
      'Englisch',
      'Französisch',
      'Hindi',
      'Japanisch',
      'Koreanisch',
      'Portugiesisch',
      'Russisch',
      'Spanisch',
    ],
    foot: ['Rechts', 'Links', 'Beide'],
    sex: ['Männlich', 'Weiblich'],
    player_types: [
      'Führungsspieler',
      'Harter Spieler',
      'Ballgewinner',
      'Geht lange Wege',
      'Spieleröffner',
      'Spielzerstörer',
      'Sechser',
      'Achter',
      'Zehner',
      'Freistoßexperte',
      'Einfache Pässe',
      'Dribbler',
      'Sturmtank',
      'Ballhalter',
      'Torjäger',
    ],
    countries: [
      'Deutschland',
      'Ägypten',
      'Albanien',
      'Algerien',
      'Andorra',
      'Angola',
      'Anguilla',
      'Antarktis',
      'Antigua und Barbuda',
      'Äquatorial Guinea',
      'Argentinien',
      'Armenien',
      'Aruba',
      'Aserbaidschan',
      'Äthiopien',
      'Australien',
      'Bahamas',
      'Bahrain',
      'Bangladesh',
      'Barbados',
      'Belgien',
      'Belize',
      'Benin',
      'Bermudas',
      'Bhutan',
      'Birma',
      'Bolivien',
      'Bosnien-Herzegowina',
      'Botswana',
      'Bouvet Inseln',
      'Brasilien',
      'Britisch-Indischer Ozean',
      'Brunei',
      'Bulgarien',
      'Burkina Faso',
      'Burundi',
      'Chile',
      'China',
      'Christmas Island',
      'Cook Inseln',
      'Costa Rica',
      'Dänemark',
      'Djibuti',
      'Dominika',
      'Dominikanische Republik',
      'Ecuador',
      'El Salvador',
      'Elfenbeinküste',
      'Eritrea',
      'Estland',
      'Falkland Inseln',
      'Färöer Inseln',
      'Fidschi',
      'Finnland',
      'Frankreich',
      'Französisch Guyana',
      'Französisch Polynesien',
      'Französisches Süd-Territorium',
      'Gabun',
      'Gambia',
      'Georgien',
      'Ghana',
      'Gibraltar',
      'Grenada',
      'Griechenland',
      'Grönland',
      'Großbritannien',
      'Guadeloupe',
      'Guam',
      'Guatemala',
      'Guinea',
      'Guinea Bissau',
      'Guyana',
      'Haiti',
      'Heard und McDonald Islands',
      'Honduras',
      'Hong Kong',
      'Indien',
      'Indonesien',
      'Irak',
      'Iran',
      'Irland',
      'Island',
      'Israel',
      'Italien',
      'Jamaika',
      'Japan',
      'Jemen',
      'Jordanien',
      'Jugoslawien',
      'Kaiman Inseln',
      'Kambodscha',
      'Kamerun',
      'Kanada',
      'Kap Verde',
      'Kasachstan',
      'Kenia',
      'Kirgisistan',
      'Kiribati',
      'Kokosinseln',
      'Kolumbien',
      'Komoren',
      'Kongo',
      'Kongo, Demokratische Republik',
      'Kroatien',
      'Kuba',
      'Kuwait',
      'Laos',
      'Lesotho',
      'Lettland',
      'Libanon',
      'Liberia',
      'Libyen',
      'Liechtenstein',
      'Litauen',
      'Luxemburg',
      'Macao',
      'Madagaskar',
      'Malawi',
      'Malaysia',
      'Malediven',
      'Mali',
      'Malta',
      'Marianen',
      'Marokko',
      'Marshall Inseln',
      'Martinique',
      'Mauretanien',
      'Mauritius',
      'Mayotte',
      'Mazedonien',
      'Mexiko',
      'Mikronesien',
      'Mocambique',
      'Moldavien',
      'Monaco',
      'Mongolei',
      'Montserrat',
      'Namibia',
      'Nauru',
      'Nepal',
      'Neukaledonien',
      'Neuseeland',
      'Nicaragua',
      'Niederlande',
      'Niederländische Antillen',
      'Niger',
      'Nigeria',
      'Niue',
      'Nord Korea',
      'Norfolk Inseln',
      'Norwegen',
      'Oman',
      'Österreich',
      'Pakistan',
      'Palästina',
      'Palau',
      'Panama',
      'Papua Neuguinea',
      'Paraguay',
      'Peru',
      'Philippinen',
      'Pitcairn',
      'Polen',
      'Portugal',
      'Puerto Rico',
      'Qatar',
      'Reunion',
      'Ruanda',
      'Rumänien',
      'Rußland',
      'Saint Lucia',
      'Sambia',
      'Samoa',
      'Samoa',
      'San Marino',
      'Sao Tome',
      'Saudi Arabien',
      'Schweden',
      'Schweiz',
      'Senegal',
      'Seychellen',
      'Sierra Leone',
      'Singapur',
      'Slowakei',
      'Slowenien',
      'Solomon Inseln',
      'Somalia',
      'South Georgia, South Sandwich Isl.',
      'Spanien',
      'Sri Lanka',
      'St. Helena',
      'St. Kitts Nevis Anguilla',
      'St. Pierre und Miquelon',
      'St. Vincent',
      'Süd Korea',
      'Südafrika',
      'Sudan',
      'Surinam',
      'Svalbard und Jan Mayen Islands',
      'Swasiland',
      'Syrien',
      'Tadschikistan',
      'Taiwan',
      'Tansania',
      'Thailand',
      'Timor',
      'Togo',
      'Tokelau',
      'Tonga',
      'Trinidad Tobago',
      'Tschad',
      'Tschechische Republik',
      'Tunesien',
      'Türkei',
      'Turkmenistan',
      'Turks und Kaikos Inseln',
      'Tuvalu',
      'Uganda',
      'Ukraine',
      'Ungarn',
      'Uruguay',
      'Usbekistan',
      'Vanuatu',
      'Vatikan',
      'Venezuela',
      'Vereinigte Arabische Emirate',
      'Vereinigte Staaten von Amerika',
      'Vietnam',
      'Virgin Island (Brit.)',
      'Virgin Island (USA)',
      'Wallis et Futuna',
      'Weissrussland',
      'Westsahara',
      'Zentralafrikanische Republik',
      'Zimbabwe',
      'Zypern',
    ],

    nationalitiesObj: {
      AD: 'Andorra',
      AE: 'Vereinigte Arabische Emirate',
      AG: 'Antigua und Barbuda',
      AI: 'Anguilla',
      AL: 'Albanien',
      AM: 'Armenien',
      AN: 'Niederländische Antillen',
      AO: 'Angola',
      AQ: 'Antarktis',
      AR: 'Argentinien',
      AS: 'Samoa',
      AT: 'Österreich',
      AU: 'Australien',
      AW: 'Aruba',
      AZ: 'Aserbaidschan',
      BA: 'Bosnien-Herzegowina',
      BB: 'Barbados',
      BD: 'Bangladesh',
      BE: 'Belgien',
      BF: 'Burkina Faso',
      BG: 'Bulgarien',
      BH: 'Bahrain',
      BI: 'Burundi',
      BJ: 'Benin',
      BM: 'Bermudas',
      BN: 'Brunei',
      BO: 'Bolivien',
      BR: 'Brasilien',
      BS: 'Bahamas',
      BT: 'Bhutan',
      BV: 'Bouvet Inseln',
      BW: 'Botswana',
      BY: 'Weissrussland',
      BZ: 'Belize',
      CA: 'Kanada',
      CC: 'Kokosinseln',
      CD: 'Kongo, Demokratische Republik',
      CF: 'Zentralafrikanische Republik',
      CG: 'Kongo',
      CH: 'Schweiz',
      CI: 'Elfenbeinküste',
      CK: 'Cook Inseln',
      CL: 'Chile',
      CM: 'Kamerun',
      CN: 'China',
      CO: 'Kolumbien',
      CR: 'Costa Rica',
      CU: 'Kuba',
      CV: 'Kap Verde',
      CX: 'Christmas Island',
      CY: 'Zypern',
      CZ: 'Tschechische Republik',
      DE: 'Deutschland',
      DJ: 'Djibuti',
      DK: 'Dänemark',
      DM: 'Dominika',
      DO: 'Dominikanische Republik',
      DZ: 'Algerien',
      EC: 'Ecuador',
      EE: 'Estland',
      EG: 'Ägypten',
      EH: 'Westsahara',
      ER: 'Eritrea',
      ES: 'Spanien',
      ET: 'Äthiopien',
      FI: 'Finnland',
      FJ: 'Fidschi',
      FK: 'Falkland Inseln',
      FM: 'Mikronesien',
      FO: 'Färöer Inseln',
      FR: 'Frankreich',
      GA: 'Gabun',
      GD: 'Grenada',
      GE: 'Georgien',
      GF: 'Französisch Guyana',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GL: 'Grönland',
      GM: 'Gambia',
      GN: 'Guinea',
      GP: 'Guadeloupe',
      GQ: 'Äquatorial Guinea',
      GR: 'Griechenland',
      GS: 'South Georgia, South Sandwich Isl.',
      GT: 'Guatemala',
      GU: 'Guam',
      GW: 'Guinea Bissau',
      GY: 'Guyana',
      HK: 'Hong Kong',
      HM: 'Heard und McDonald Islands',
      HN: 'Honduras',
      HR: 'Kroatien',
      HT: 'Haiti',
      HU: 'Ungarn',
      ID: 'Indonesien',
      IE: 'Irland',
      IL: 'Israel',
      IN: 'Indien',
      IO: 'Britisch-Indischer Ozean',
      IQ: 'Irak',
      IR: 'Iran',
      IS: 'Island',
      IT: 'Italien',
      JM: 'Jamaika',
      JO: 'Jordanien',
      JP: 'Japan',
      KE: 'Kenia',
      KG: 'Kirgisistan',
      KH: 'Kambodscha',
      KI: 'Kiribati',
      KM: 'Komoren',
      KN: 'St. Kitts Nevis Anguilla',
      KP: 'Nord Korea',
      KR: 'Süd Korea',
      KW: 'Kuwait',
      KY: 'Kaiman Inseln',
      KZ: 'Kasachstan',
      LA: 'Laos',
      LB: 'Libanon',
      LC: 'Saint Lucia',
      LI: 'Liechtenstein',
      LK: 'Sri Lanka',
      LR: 'Liberia',
      LS: 'Lesotho',
      LT: 'Litauen',
      LU: 'Luxemburg',
      LV: 'Lettland',
      LY: 'Libyen',
      MA: 'Marokko',
      MC: 'Monaco',
      MD: 'Moldavien',
      MG: 'Madagaskar',
      MH: 'Marshall Inseln',
      MK: 'Mazedonien',
      ML: 'Mali',
      MM: 'Birma',
      MN: 'Mongolei',
      MO: 'Macao',
      MP: 'Marianen',
      MQ: 'Martinique',
      MR: 'Mauretanien',
      MS: 'Montserrat',
      MT: 'Malta',
      MU: 'Mauritius',
      MV: 'Malediven',
      MW: 'Malawi',
      MX: 'Mexiko',
      MY: 'Malaysia',
      MZ: 'Mocambique',
      NA: 'Namibia',
      NC: 'Neukaledonien',
      NE: 'Niger',
      NF: 'Norfolk Inseln',
      NG: 'Nigeria',
      NI: 'Nicaragua',
      NL: 'Niederlande',
      NO: 'Norwegen',
      NP: 'Nepal',
      NR: 'Nauru',
      NU: 'Niue',
      NZ: 'Neuseeland',
      OM: 'Oman',
      PA: 'Panama',
      PE: 'Peru',
      PF: 'Französisch Polynesien',
      PG: 'Papua Neuguinea',
      PH: 'Philippinen',
      PK: 'Pakistan',
      PL: 'Polen',
      PM: 'St. Pierre und Miquelon',
      PN: 'Pitcairn',
      PR: 'Puerto Rico',
      PS: 'Palästina',
      PT: 'Portugal',
      PW: 'Palau',
      PY: 'Paraguay',
      QA: 'Qatar',
      RE: 'Reunion',
      RO: 'Rumänien',
      RU: 'Rußland',
      RW: 'Ruanda',
      SA: 'Saudi Arabien',
      SB: 'Solomon Inseln',
      SC: 'Seychellen',
      SD: 'Sudan',
      SE: 'Schweden',
      SG: 'Singapur',
      SH: 'St. Helena',
      SI: 'Slowenien',
      SJ: 'Svalbard und Jan Mayen Islands',
      SK: 'Slowakei',
      SL: 'Sierra Leone',
      SM: 'San Marino',
      SN: 'Senegal',
      SO: 'Somalia',
      SR: 'Surinam',
      ST: 'Sao Tome',
      SV: 'El Salvador',
      SY: 'Syrien',
      SZ: 'Swasiland',
      TC: 'Turks und Kaikos Inseln',
      TD: 'Tschad',
      TF: 'Französisches Süd-Territorium',
      TG: 'Togo',
      TH: 'Thailand',
      TJ: 'Tadschikistan',
      TK: 'Tokelau',
      TM: 'Turkmenistan',
      TN: 'Tunesien',
      TO: 'Tonga',
      TP: 'Timor',
      TR: 'Türkei',
      TT: 'Trinidad Tobago',
      TV: 'Tuvalu',
      TW: 'Taiwan',
      TZ: 'Tansania',
      UA: 'Ukraine',
      UG: 'Uganda',
      UK: 'Großbritannien',
      US: 'Vereinigte Staaten von Amerika',
      UY: 'Uruguay',
      UZ: 'Usbekistan',
      VA: 'Vatikan',
      VC: 'St. Vincent',
      VE: 'Venezuela',
      VG: 'Virgin Island (Brit.)',
      VI: 'Virgin Island (USA)',
      VN: 'Vietnam',
      VU: 'Vanuatu',
      WF: 'Wallis et Futuna',
      WS: 'Samoa',
      YE: 'Jemen',
      YT: 'Mayotte',
      YU: 'Jugoslawien',
      ZA: 'Südafrika',
      ZM: 'Sambia',
      ZW: 'Zimbabwe',
    },

    nationalities: [{
      id: 'DE',
      item_text: 'Deutschland',
    },
    {
      id: 'EG',
      item_text: 'Ägypten',
    },
    {
      id: 'AL',
      item_text: 'Albanien',
    },
    {
      id: 'DZ',
      item_text: 'Algerien',
    },
    {
      id: 'AD',
      item_text: 'Andorra',
    },
    {
      id: 'AO',
      item_text: 'Angola',
    },
    {
      id: 'AI',
      item_text: 'Anguilla',
    },
    {
      id: 'AQ',
      item_text: 'Antarktis',
    },
    {
      id: 'AG',
      item_text: 'Antigua und Barbuda',
    },
    {
      id: 'GQ',
      item_text: 'Äquatorial Guinea',
    },
    {
      id: 'AR',
      item_text: 'Argentinien',
    },
    {
      id: 'AM',
      item_text: 'Armenien',
    },
    {
      id: 'AW',
      item_text: 'Aruba',
    },
    {
      id: 'AZ',
      item_text: 'Aserbaidschan',
    },
    {
      id: 'ET',
      item_text: 'Äthiopien',
    },
    {
      id: 'AU',
      item_text: 'Australien',
    },
    {
      id: 'BS',
      item_text: 'Bahamas',
    },
    {
      id: 'BH',
      item_text: 'Bahrain',
    },
    {
      id: 'BD',
      item_text: 'Bangladesh',
    },
    {
      id: 'BB',
      item_text: 'Barbados',
    },
    {
      id: 'BE',
      item_text: 'Belgien',
    },
    {
      id: 'BZ',
      item_text: 'Belize',
    },
    {
      id: 'BJ',
      item_text: 'Benin',
    },
    {
      id: 'BM',
      item_text: 'Bermudas',
    },
    {
      id: 'BT',
      item_text: 'Bhutan',
    },
    {
      id: 'MM',
      item_text: 'Birma',
    },
    {
      id: 'BO',
      item_text: 'Bolivien',
    },
    {
      id: 'BA',
      item_text: 'Bosnien-Herzegowina',
    },
    {
      id: 'BW',
      item_text: 'Botswana',
    },
    {
      id: 'BV',
      item_text: 'Bouvet Inseln',
    },
    {
      id: 'BR',
      item_text: 'Brasilien',
    },
    {
      id: 'IO',
      item_text: 'Britisch-Indischer Ozean',
    },
    {
      id: 'BN',
      item_text: 'Brunei',
    },
    {
      id: 'BG',
      item_text: 'Bulgarien',
    },
    {
      id: 'BF',
      item_text: 'Burkina Faso',
    },
    {
      id: 'BI',
      item_text: 'Burundi',
    },
    {
      id: 'CL',
      item_text: 'Chile',
    },
    {
      id: 'CN',
      item_text: 'China',
    },
    {
      id: 'CX',
      item_text: 'Christmas Island',
    },
    {
      id: 'CK',
      item_text: 'Cook Inseln',
    },
    {
      id: 'CR',
      item_text: 'Costa Rica',
    },
    {
      id: 'DK',
      item_text: 'Dänemark',
    },
    {
      id: 'DJ',
      item_text: 'Djibuti',
    },
    {
      id: 'DM',
      item_text: 'Dominika',
    },
    {
      id: 'DO',
      item_text: 'Dominikanische Republik',
    },
    {
      id: 'EC',
      item_text: 'Ecuador',
    },
    {
      id: 'SV',
      item_text: 'El Salvador',
    },
    {
      id: 'CI',
      item_text: 'Elfenbeinküste',
    },
    {
      id: 'ER',
      item_text: 'Eritrea',
    },
    {
      id: 'EE',
      item_text: 'Estland',
    },
    {
      id: 'FK',
      item_text: 'Falkland Inseln',
    },
    {
      id: 'FO',
      item_text: 'Färöer Inseln',
    },
    {
      id: 'FJ',
      item_text: 'Fidschi',
    },
    {
      id: 'FI',
      item_text: 'Finnland',
    },
    {
      id: 'FR',
      item_text: 'Frankreich',
    },
    {
      id: 'GF',
      item_text: 'Französisch Guyana',
    },
    {
      id: 'PF',
      item_text: 'Französisch Polynesien',
    },
    {
      id: 'TF',
      item_text: 'Französisches Süd-Territorium',
    },
    {
      id: 'GA',
      item_text: 'Gabun',
    },
    {
      id: 'GM',
      item_text: 'Gambia',
    },
    {
      id: 'GE',
      item_text: 'Georgien',
    },
    {
      id: 'GH',
      item_text: 'Ghana',
    },
    {
      id: 'GI',
      item_text: 'Gibraltar',
    },
    {
      id: 'GD',
      item_text: 'Grenada',
    },
    {
      id: 'GR',
      item_text: 'Griechenland',
    },
    {
      id: 'GL',
      item_text: 'Grönland',
    },
    {
      id: 'UK',
      item_text: 'Großbritannien',
    },
    {
      id: 'GP',
      item_text: 'Guadeloupe',
    },
    {
      id: 'GU',
      item_text: 'Guam',
    },
    {
      id: 'GT',
      item_text: 'Guatemala',
    },
    {
      id: 'GN',
      item_text: 'Guinea',
    },
    {
      id: 'GW',
      item_text: 'Guinea Bissau',
    },
    {
      id: 'GY',
      item_text: 'Guyana',
    },
    {
      id: 'HT',
      item_text: 'Haiti',
    },
    {
      id: 'HM',
      item_text: 'Heard und McDonald Islands',
    },
    {
      id: 'HN',
      item_text: 'Honduras',
    },
    {
      id: 'HK',
      item_text: 'Hong Kong',
    },
    {
      id: 'IN',
      item_text: 'Indien',
    },
    {
      id: 'ID',
      item_text: 'Indonesien',
    },
    {
      id: 'IQ',
      item_text: 'Irak',
    },
    {
      id: 'IR',
      item_text: 'Iran',
    },
    {
      id: 'IE',
      item_text: 'Irland',
    },
    {
      id: 'IS',
      item_text: 'Island',
    },
    {
      id: 'IL',
      item_text: 'Israel',
    },
    {
      id: 'IT',
      item_text: 'Italien',
    },
    {
      id: 'JM',
      item_text: 'Jamaika',
    },
    {
      id: 'JP',
      item_text: 'Japan',
    },
    {
      id: 'YE',
      item_text: 'Jemen',
    },
    {
      id: 'JO',
      item_text: 'Jordanien',
    },
    {
      id: 'YU',
      item_text: 'Jugoslawien',
    },
    {
      id: 'KY',
      item_text: 'Kaiman Inseln',
    },
    {
      id: 'KH',
      item_text: 'Kambodscha',
    },
    {
      id: 'CM',
      item_text: 'Kamerun',
    },
    {
      id: 'CA',
      item_text: 'Kanada',
    },
    {
      id: 'CV',
      item_text: 'Kap Verde',
    },
    {
      id: 'KZ',
      item_text: 'Kasachstan',
    },
    {
      id: 'KE',
      item_text: 'Kenia',
    },
    {
      id: 'KG',
      item_text: 'Kirgisistan',
    },
    {
      id: 'KI',
      item_text: 'Kiribati',
    },
    {
      id: 'CC',
      item_text: 'Kokosinseln',
    },
    {
      id: 'CO',
      item_text: 'Kolumbien',
    },
    {
      id: 'KM',
      item_text: 'Komoren',
    },
    {
      id: 'CG',
      item_text: 'Kongo',
    },
    {
      id: 'CD',
      item_text: 'Kongo, Demokratische Republik',
    },
    {
      id: 'HR',
      item_text: 'Kroatien',
    },
    {
      id: 'CU',
      item_text: 'Kuba',
    },
    {
      id: 'KW',
      item_text: 'Kuwait',
    },
    {
      id: 'LA',
      item_text: 'Laos',
    },
    {
      id: 'LS',
      item_text: 'Lesotho',
    },
    {
      id: 'LV',
      item_text: 'Lettland',
    },
    {
      id: 'LB',
      item_text: 'Libanon',
    },
    {
      id: 'LR',
      item_text: 'Liberia',
    },
    {
      id: 'LY',
      item_text: 'Libyen',
    },
    {
      id: 'LI',
      item_text: 'Liechtenstein',
    },
    {
      id: 'LT',
      item_text: 'Litauen',
    },
    {
      id: 'LU',
      item_text: 'Luxemburg',
    },
    {
      id: 'MO',
      item_text: 'Macao',
    },
    {
      id: 'MG',
      item_text: 'Madagaskar',
    },
    {
      id: 'MW',
      item_text: 'Malawi',
    },
    {
      id: 'MY',
      item_text: 'Malaysia',
    },
    {
      id: 'MV',
      item_text: 'Malediven',
    },
    {
      id: 'ML',
      item_text: 'Mali',
    },
    {
      id: 'MT',
      item_text: 'Malta',
    },
    {
      id: 'MP',
      item_text: 'Marianen',
    },
    {
      id: 'MA',
      item_text: 'Marokko',
    },
    {
      id: 'MH',
      item_text: 'Marshall Inseln',
    },
    {
      id: 'MQ',
      item_text: 'Martinique',
    },
    {
      id: 'MR',
      item_text: 'Mauretanien',
    },
    {
      id: 'MU',
      item_text: 'Mauritius',
    },
    {
      id: 'YT',
      item_text: 'Mayotte',
    },
    {
      id: 'MK',
      item_text: 'Mazedonien',
    },
    {
      id: 'MX',
      item_text: 'Mexiko',
    },
    {
      id: 'FM',
      item_text: 'Mikronesien',
    },
    {
      id: 'MZ',
      item_text: 'Mocambique',
    },
    {
      id: 'MD',
      item_text: 'Moldavien',
    },
    {
      id: 'MC',
      item_text: 'Monaco',
    },
    {
      id: 'MN',
      item_text: 'Mongolei',
    },
    {
      id: 'MS',
      item_text: 'Montserrat',
    },
    {
      id: 'NA',
      item_text: 'Namibia',
    },
    {
      id: 'NR',
      item_text: 'Nauru',
    },
    {
      id: 'NP',
      item_text: 'Nepal',
    },
    {
      id: 'NC',
      item_text: 'Neukaledonien',
    },
    {
      id: 'NZ',
      item_text: 'Neuseeland',
    },
    {
      id: 'NI',
      item_text: 'Nicaragua',
    },
    {
      id: 'NL',
      item_text: 'Niederlande',
    },
    {
      id: 'AN',
      item_text: 'Niederländische Antillen',
    },
    {
      id: 'NE',
      item_text: 'Niger',
    },
    {
      id: 'NG',
      item_text: 'Nigeria',
    },
    {
      id: 'NU',
      item_text: 'Niue',
    },
    {
      id: 'KP',
      item_text: 'Nord Korea',
    },
    {
      id: 'NF',
      item_text: 'Norfolk Inseln',
    },
    {
      id: 'NO',
      item_text: 'Norwegen',
    },
    {
      id: 'OM',
      item_text: 'Oman',
    },
    {
      id: 'AT',
      item_text: 'Österreich',
    },
    {
      id: 'PK',
      item_text: 'Pakistan',
    },
    {
      id: 'PS',
      item_text: 'Palästina',
    },
    {
      id: 'PW',
      item_text: 'Palau',
    },
    {
      id: 'PA',
      item_text: 'Panama',
    },
    {
      id: 'PG',
      item_text: 'Papua Neuguinea',
    },
    {
      id: 'PY',
      item_text: 'Paraguay',
    },
    {
      id: 'PE',
      item_text: 'Peru',
    },
    {
      id: 'PH',
      item_text: 'Philippinen',
    },
    {
      id: 'PN',
      item_text: 'Pitcairn',
    },
    {
      id: 'PL',
      item_text: 'Polen',
    },
    {
      id: 'PT',
      item_text: 'Portugal',
    },
    {
      id: 'PR',
      item_text: 'Puerto Rico',
    },
    {
      id: 'QA',
      item_text: 'Qatar',
    },
    {
      id: 'RE',
      item_text: 'Reunion',
    },
    {
      id: 'RW',
      item_text: 'Ruanda',
    },
    {
      id: 'RO',
      item_text: 'Rumänien',
    },
    {
      id: 'RU',
      item_text: 'Rußland',
    },
    {
      id: 'LC',
      item_text: 'Saint Lucia',
    },
    {
      id: 'ZM',
      item_text: 'Sambia',
    },
    {
      id: 'AS',
      item_text: 'Samoa',
    },
    {
      id: 'WS',
      item_text: 'Samoa',
    },
    {
      id: 'SM',
      item_text: 'San Marino',
    },
    {
      id: 'ST',
      item_text: 'Sao Tome',
    },
    {
      id: 'SA',
      item_text: 'Saudi Arabien',
    },
    {
      id: 'SE',
      item_text: 'Schweden',
    },
    {
      id: 'CH',
      item_text: 'Schweiz',
    },
    {
      id: 'SN',
      item_text: 'Senegal',
    },
    {
      id: 'SC',
      item_text: 'Seychellen',
    },
    {
      id: 'SL',
      item_text: 'Sierra Leone',
    },
    {
      id: 'SG',
      item_text: 'Singapur',
    },
    {
      id: 'SK',
      item_text: 'Slowakei',
    },
    {
      id: 'SI',
      item_text: 'Slowenien',
    },
    {
      id: 'SB',
      item_text: 'Solomon Inseln',
    },
    {
      id: 'SO',
      item_text: 'Somalia',
    },
    {
      id: 'GS',
      item_text: 'South Georgia, South Sandwich Isl.',
    },
    {
      id: 'ES',
      item_text: 'Spanien',
    },
    {
      id: 'LK',
      item_text: 'Sri Lanka',
    },
    {
      id: 'SH',
      item_text: 'St. Helena',
    },
    {
      id: 'KN',
      item_text: 'St. Kitts Nevis Anguilla',
    },
    {
      id: 'PM',
      item_text: 'St. Pierre und Miquelon',
    },
    {
      id: 'VC',
      item_text: 'St. Vincent',
    },
    {
      id: 'KR',
      item_text: 'Süd Korea',
    },
    {
      id: 'ZA',
      item_text: 'Südafrika',
    },
    {
      id: 'SD',
      item_text: 'Sudan',
    },
    {
      id: 'SR',
      item_text: 'Surinam',
    },
    {
      id: 'SJ',
      item_text: 'Svalbard und Jan Mayen Islands',
    },
    {
      id: 'SZ',
      item_text: 'Swasiland',
    },
    {
      id: 'SY',
      item_text: 'Syrien',
    },
    {
      id: 'TJ',
      item_text: 'Tadschikistan',
    },
    {
      id: 'TW',
      item_text: 'Taiwan',
    },
    {
      id: 'TZ',
      item_text: 'Tansania',
    },
    {
      id: 'TH',
      item_text: 'Thailand',
    },
    {
      id: 'TP',
      item_text: 'Timor',
    },
    {
      id: 'TG',
      item_text: 'Togo',
    },
    {
      id: 'TK',
      item_text: 'Tokelau',
    },
    {
      id: 'TO',
      item_text: 'Tonga',
    },
    {
      id: 'TT',
      item_text: 'Trinidad Tobago',
    },
    {
      id: 'TD',
      item_text: 'Tschad',
    },
    {
      id: 'CZ',
      item_text: 'Tschechische Republik',
    },
    {
      id: 'TN',
      item_text: 'Tunesien',
    },
    {
      id: 'TR',
      item_text: 'Türkei',
    },
    {
      id: 'TM',
      item_text: 'Turkmenistan',
    },
    {
      id: 'TC',
      item_text: 'Turks und Kaikos Inseln',
    },
    {
      id: 'TV',
      item_text: 'Tuvalu',
    },
    {
      id: 'UG',
      item_text: 'Uganda',
    },
    {
      id: 'UA',
      item_text: 'Ukraine',
    },
    {
      id: 'HU',
      item_text: 'Ungarn',
    },
    {
      id: 'UY',
      item_text: 'Uruguay',
    },
    {
      id: 'UZ',
      item_text: 'Usbekistan',
    },
    {
      id: 'VU',
      item_text: 'Vanuatu',
    },
    {
      id: 'VA',
      item_text: 'Vatikan',
    },
    {
      id: 'VE',
      item_text: 'Venezuela',
    },
    {
      id: 'AE',
      item_text: 'Vereinigte Arabische Emirate',
    },
    {
      id: 'US',
      item_text: 'Vereinigte Staaten von Amerika',
    },
    {
      id: 'VN',
      item_text: 'Vietnam',
    },
    {
      id: 'VG',
      item_text: 'Virgin Island (Brit.)',
    },
    {
      id: 'VI',
      item_text: 'Virgin Island (USA)',
    },
    {
      id: 'WF',
      item_text: 'Wallis et Futuna',
    },
    {
      id: 'BY',
      item_text: 'Weissrussland',
    },
    {
      id: 'EH',
      item_text: 'Westsahara',
    },
    {
      id: 'CF',
      item_text: 'Zentralafrikanische Republik',
    },
    {
      id: 'ZW',
      item_text: 'Zimbabwe',
    },
    {
      id: 'CY',
      item_text: 'Zypern',
    },
    ],
    userWatchlist: {},
  },

  mutations: {
    ...vuexfireMutations,

    updateOnlineUsersForFilters(state, payload) {
      state.onlineUsersForFilters = [...payload];
    },

    addOnlineChatUser(state, id) {
      state.onlineChatUsers.push(id);
    },

    removeOnlineChatUser(state, id) {
      state.onlineChatUsers = state.onlineChatUsers.filter(u => u !== id);
    },

    setUserMatches(state, payload) {
      console.log('set user matches');
      state.userMatches = payload;
    },

    updatePlayersConnected(state, payload) {
      state.playersConnected = payload;
    },

    updateTrainersConnected(state, payload) {
      state.trainersConnected = payload;
    },

    openSnackbar(state, payload) {
      state.snackText = payload.text;
      state.snackbar = true;
    },

    registerPlayer(state, payload) {
      const {
        email,
      } = payload;
      const {
        password,
      } = payload;
      const data = {
        email,
        password,
      };
      const json = JSON.stringify(data);
      return axios({
        method: 'post',
        url: `${cloudFunctions}/createPlayer`,
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        data: json,
      })
        .then((resp) => {
          state.snackText = 'Nutzer erfolgreich angemeldet';
          state.snackbar = true;
        })
        .catch((error) => {});
    },

    setUserData(state) {
      db.collection('users')
        .doc(state.user_id)
        .get({ source: 'server' })
        .then((snapshot) => {
          const document = snapshot.data();
          state.user_data = document;
        });
    },

    setBindedUserData(state, payload) {
      state.bindedUserData = payload;
      state.user_data = {
        ...state.user_data,
        ...payload,
      };
    },

    setUnsubscribeBindedUser(state, payload) {
      state.bindUserUnsubscribe = payload;
    },

    setSubscriptionData(state, payload) {
      state.subscriptionData = payload;
    },
    setUserPayments(state, payload) {
      state.payments = payload;
    },
    setUserWatchlist(state, payload) {
      state.userWatchlist = payload;
    },
    setUserFreeSwipes(state, payload) {
      state.swipesLeft = payload;
    },
  },

  getters: {
    userAppliedTeamsWithoutMatch: (state) => {
      if (state.bindedUserData && state.bindedUserData.applied_teams && state.bindedUserData.matches) {
        return state.bindedUserData.applied_teams.filter(teamId => !state.bindedUserData.matches.some(m => m.startsWith(teamId)));
      }

      if (state.user_data && state.user_data.applied_teams && state.user_data.matches) {
        return state.user_data.applied_teams.filter(teamId => !state.user_data.matches.some(m => m.startsWith(teamId)));
      }

      return [];
    },
    userAppliedPlayersWithoutMatch: (state) => {
      if (state.bindedUserData && state.bindedUserData.applications && state.bindedUserData.matches) {
        return state.bindedUserData.applications.filter(playerId => !state.bindedUserData.matches.some(m => m.startsWith(playerId)));
      }

      if (state.user_data && state.user_data.applications && state.user_data.matches) {
        return state.user_data.applications.filter(playerId => !state.user_data.matches.some(m => m.startsWith(playerId)));
      }

      return [];
    },
    userAppliedTrainersWithoutMatch: (state) => {
      if (state.bindedUserData && state.bindedUserData.trainer_applications && state.bindedUserData.matches) {
        return state.bindedUserData.trainer_applications.filter(trainerId => !state.bindedUserData.matches.some(m => m.startsWith(trainerId)));
      }

      if (state.user_data && state.user_data.trainer_applications && state.user_data.matches) {
        return state.user_data.trainer_applications.filter(trainerId => !state.user_data.matches.some(m => m.startsWith(trainerId)));
      }

      return [];
    },
    watchlistProfileIds: state => Object.keys(state.userWatchlist),
  },

  actions: {
    bindUserData({ commit, state }) {
      // add only one listener?
      if (state.watchUserDataActive) {
        const userRef = db.collection(state.userType).doc(state.user_id);
        console.log('bind user data called');
        // use unsubscribe as reference to close/detach listener after logout
        const unsubscribe = userRef.onSnapshot((userChanged) => {
          console.log('userdata changed');
          const data = userChanged.data();
          commit('setBindedUserData', data);
        });
        commit('setUnsubscribeBindedUser', unsubscribe);
      }
    },

    setSubscriptionData({ commit, state }) {
      if (!state.user_data.subscription_id) {
        return;
      }

      db.collection('subscriptions')
        .doc(state.user_data.subscription_id)
        .get({ source: 'server' })
        .then((snapshot) => {
          const document = snapshot.data();
          commit('setSubscriptionData', document);
        });
    },

    setUserPayments({ commit, state }) {
      db.collection('payments')
        .where('account_id', '==', state.user_data.id)
        .orderBy('timestamp', 'desc')
        .get()
        .then((snapshot) => {
          const data = [];
          snapshot.forEach(s => data.push(s.data()));
          commit('setUserPayments', data);
        });
    },

    loadUserWatchlist({ commit, state }) {
      console.log('load watchlist');
      db.collection('watchlist')
        .doc(state.user_data.id)
        .get({ source: 'server' })
        .then((snapshot) => {
          const document = snapshot.data();
          commit('setUserWatchlist', document || {});
        });
    },

    setUserWatchlist({ commit, state }, updatedData) {
      db.collection('watchlist')
        .doc(state.user_data.id)
        .set(updatedData)
        .then(() => {
          commit('setUserWatchlist', updatedData);
        });
    },

    setUserFreeSwipes({ commit, state }) {
      const collection = state.user_data.userType === 'player' ? 'users' : 'trainers';
      const freeSwipes = 5;

      db.collection(collection)
        .doc(state.user_data.id)
        .update({
          swipesLeft: freeSwipes,
        })
        .then(() => {
          commit('setUserFreeSwipes', freeSwipes);
        });
    },

    // sometimes works, sometimes throw error and app is not stable

    // bindUserData: firestoreAction((context) => {
    //   // context contains all original properties like commit, state, etc
    //   // and adds `bindFirestoreRef` and `unbindFirestoreRef`
    //   // we return the promise returned by `bindFirestoreRef` that will
    //   // resolve once data is ready
    //   console.log('bindUserData', context.state.user_id);
    //   return context.bindFirestoreRef('bindedUserData',
    //     db.collection(context.state.userType)
    //       .doc(context.state.user_id));
    // }),
  },
});
